import React, { Component } from 'react';
import globals from "../globals";

class FancyInput extends Component {

	componentDidMount() {
		if (this.props.value && this.props.value.length > 0) {
			this.input.classList.add('input--filled');
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value !== prevProps.value && this.props.value && this.props.value.length > 0) {
            this.input.classList.add('input--filled');
        }
    }

    handleFocus(event) {
        event.target.parentNode.classList.add('input--filled');

        if (this.props.handleFocus) {
            this.props.handleFocus(event);
        }
    }

    handleBlur(event) {
        if (event.target.value.trim() === '') {
            event.target.parentNode.classList.remove('input--filled');
        }

        globals.setSessionVar(event.target.name, event.target.value);
    }

    render() {
        return (
            <span className={'input input--nao input-' + this.props.name + ' ' + (this.props.filled ? 'input--filled' : '')} ref={el => this.input = el}>
                <input
                    className={`input__field input__field--nao ${this.props.className}`}
                    name={this.props.name}
                    value={this.props.value}
                    maxLength={(this.props.maxLength ? this.props.maxLength : 255)}
                    onFocus={this.handleFocus.bind(this)}
                    onBlur={this.handleBlur.bind(this)}
                    onChange={this.props.handleChange}
                    onKeyDown={this.props.handleKeyDown}
                    type={this.props.type ? this.props.type : 'text'}
                />
                <label className="input__label input__label--nao">
                    <span className="input__label-content input__label-content--nao">
                        {this.props.label}
                    </span>
                </label>
                <svg className="graphic graphic--nao" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                    <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                </svg>
            </span>
        );
    }

}

export default FancyInput;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/FancyInput.js